import { render, staticRenderFns } from "./RFQCard.vue?vue&type=template&id=61e23afc&scoped=true&"
import script from "./RFQCard.vue?vue&type=script&lang=js&"
export * from "./RFQCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e23afc",
  null
  
)

export default component.exports